<template>
  <div class="scores-container">
    <span class="category-title f-ui-3">{{ category || ' ' }}</span>
    <div class="scorecard-coverage">
      <slot />
    </div>
    <div
      class="region-group"
      v-for="regionGroup in regionGroups"
      :key="regionGroup.name"
    >
      <span class="f-ui-2-bold">{{
        showRegions ? regionGroup.name : "&nbsp;"
      }}</span>
      <ul class="scores">
        <li v-for="region in regionGroup.regions" :key="region">
          <div
            v-if="showRegions"
            class="region"
            @click="() => selectRegion(region)"
          >
            {{ region }}
          </div>
          <div class="score" v-if="showScores">
            <div
              class="score-radius"
              :class="getStatus(region, category)"
            ></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import eu27 from "@/assets/eu27.json";
export default {
  props: {
    regionGroups: {
      type: Array,
      required: true,
    },
    category: {
        type: String,
        required: false
    },
    showRegions: {
      type: Boolean,
      default: false,
    },
    showScores: {
      type: Boolean,
      default: false,
    },
    policies: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStatus(region, category) {
      const { policies } = this;
      return policies.reduce((status, policy) => {
        const countryLevelPolicy = policy.country === region;
        const coveredByEU =
          policy.country === "European Union" && eu27.includes(region);
        if (!countryLevelPolicy && !coveredByEU) return status;
        if (category && policy.category && !policy.category.includes(category))
          return status;
        if (policy.status === "Achieved" || status === "achieved")
          return "achieved";
        if (
          (policy.status === "In force" && countryLevelPolicy) ||
          status === "in-force"
        )
          return "in-force";
        if ((policy.status === "In force" && coveredByEU) || status === "EU")
          return "in-force"; // 'EU';
        if (policy.status === "Announced" || status === "announced")
          return "announced";
        // if (policy.status === "Ended" || status === "ended") return "ended";
        return "none";
      }, "none");
    },
    selectRegion(region) {
      this.$emit("select:region", region);
    },
  },
};
</script>

<style scoped>
.scorecard-coverage {
    display: flex;
    align-items: center;
    justify-content: center;
  min-height: 86px;
  max-width: 240px;
  /* border-bottom: 1px solid #f2f2f2; */
}
.scores-container {
  flex: 1;
  position: relative;
  max-width: 240px;
}
.scores-container .category-title {
  display: block;
  width: 100%;
  text-align: center;
    min-height: 3.25rem;
    max-height: 3.25rem;
  overflow: hidden;
  padding-top: 4px;
}
.region-group {
  padding-top: 12px;
}
.region-group:last-child {
  padding-top: 24px;
}
.region-group span {
  padding: 6px 8px;
  display: block;
}
.region {
  cursor: pointer;
}
.region:hover {
  text-decoration: underline;
}
.region:hover:before {
  opacity: 0.15;
}
.scores li:nth-child(even) {
  background: #fff;
}
.scores li:nth-child(odd) {
  background: #f2f2f2;
}
.scores {
  /*padding-top: 26px;*/
  padding-left: 0 !important;
}
.scores li {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 0.875rem;
  line-height: 0.875rem;
  padding: 6px 8px;
}
.scores li:before {
  content: none !important;
}
@media screen and (max-width: 959px) {
  .scores-container {
    flex: 1 0 auto;
    max-width: unset;
    min-width: 120px;
  }
  .region {
    min-width: 180px;
  }
}
</style>